export default __webpack_public_path__ + "static/media/where-to-find-my-tyre-size.9d55ac52.png";